import { Grid, IconButton } from '@mui/material';
import React from 'react';

export default function CircleDays({ weekDays, onActiveDay }) {
  return weekDays.map((i) => (
    <IconButton
      onClick={() => onActiveDay(i)}
      key={i.name}
      aria-label="fingerprint"
      color="primary"
      style={{
        background: i.active ? '#0997ba' : '#cac9c9',
        width: 40,
        height: 40,
        marginRight: 15,
      }}>
      <p style={{ color: 'white' }}>{i.initialCharacter}</p>
    </IconButton>
  ));
}
